import { render, staticRenderFns } from "./SectionFour.vue?vue&type=template&id=657ace42"
import script from "./SectionFour.vue?vue&type=script&lang=js"
export * from "./SectionFour.vue?vue&type=script&lang=js"
import style0 from "./SectionFour.vue?vue&type=style&index=0&id=657ace42&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports